import {Component, inject, Injector, OnInit} from '@angular/core';
import {CommandTemplateModel, ICommandTemplateCreateModel} from "../../../../services/commands.service";
import {DialogBaseComponent} from "../../base-admin-panel/dialog-base/dialog-base.component";
import {ObjectModel} from "../../../../models/ObjectModel";
import {ObjectsService} from "../../../../services/objects.service";
import ol from "ol/dist/ol";
import obj = ol.obj;
import {ObjectLiteViewModel} from "../../../../models/ObjectLiteViewModel";

export interface ICommandModel {
  Name: string;
  Command: string;
  ObjectIds: number[];
}

@Component({
    selector: 'app-command-dialog-base',
    templateUrl: './command-dialog-base.component.html',
    styleUrls: ['./command-dialog-base.component.css'],
    standalone: false
})
export class CommandDialogBaseComponent<T extends ICommandModel> extends DialogBaseComponent<T> {
  public allObjects: ObjectLiteViewModel[] = [];
  public isLoading: boolean = true;
  public objectService: ObjectsService = inject(ObjectsService);
  constructor(protected injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.isLoading = true;
    this.objectService.GetLiteObjects().subscribe(objects => {
      this.allObjects = objects;
      this.isLoading = false;
    }, () => {
      this.isLoading = false;
    });
  }
}
